import { render, staticRenderFns } from "./SkillIcon.vue?vue&type=template&id=308214c6&"
import script from "./SkillIcon.vue?vue&type=script&lang=js&"
export * from "./SkillIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports